import { render, staticRenderFns } from "./TwProcessDetail.vue?vue&type=template&id=29887fe3&scoped=true&"
import script from "./TwProcessDetail.vue?vue&type=script&lang=js&"
export * from "./TwProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessDetail.vue?vue&type=style&index=0&id=29887fe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29887fe3",
  null
  
)

export default component.exports